import { z } from 'zod';
import { idSchema } from './common.js';
import { financialEntrySchema } from './financeiro.js';
import { fiscalDocumentStatusSchema, fiscalTargetStatusSchema, purchaseOrderStatusSchema, } from './compras.js';
/**
 * Resumo financeiro de uma pessoa — o "dashboardzinho" do fornecedor.
 *
 * Responde às perguntas que quem paga faz antes de ligar para o fornecedor:
 * quanto já gastei com ele, quanto ainda devo, o que está vencido, o que ele
 * me vendeu por último. Tudo em centavos e tudo derivado dos lançamentos,
 * pedidos e notas que já existem — este resumo não guarda nada.
 */
/** Um mês de compras, para o gráfico dos últimos doze. */
export const personMonthSchema = z.object({
    /** `YYYY-MM`. */
    month: z.string(),
    totalCents: z.number().int(),
});
/** Pedido de compra resumido: o que a lista do fornecedor precisa mostrar. */
export const personOrderDigestSchema = z.object({
    id: idSchema,
    code: z.string(),
    status: purchaseOrderStatusSchema,
    totalCents: z.number().int(),
    createdAt: z.string(),
    expectedAt: z.string().nullable(),
    receivedAt: z.string().nullable(),
});
/** Nota fiscal resumida. */
export const personDocumentDigestSchema = z.object({
    id: idSchema,
    number: z.string(),
    series: z.string().nullable(),
    issueDate: z.string(),
    totalCents: z.number().int(),
    status: fiscalDocumentStatusSchema,
    financialStatus: fiscalTargetStatusSchema,
});
export const personSummarySchema = z.object({
    personId: idSchema,
    /** Soma de todo lançamento não cancelado com esta pessoa, desde sempre. */
    totalCents: z.number().int(),
    /** Quanto já foi pago de fato (baixas líquidas de estorno). */
    paidCents: z.number().int(),
    /** Parcelas em aberto ou parcialmente pagas: o que ainda se deve. */
    openCents: z.number().int(),
    /** Parte do em aberto cujo vencimento já passou. */
    overdueCents: z.number().int(),
    /** Mesmo cálculo, só com competência no ano corrente. */
    yearTotalCents: z.number().int(),
    yearPaidCents: z.number().int(),
    /** Quantidades, para o operador ter noção do volume. */
    entriesCount: z.number().int(),
    /**
     * Pedidos e notas vêm NULOS quando quem pergunta não tem
     * `pedidos-compra:ver` / `documentos-fiscais:ver` — o resumo não pode
     * mostrar pela porta lateral o que a tela de Compras esconde.
     */
    purchaseOrdersCount: z.number().int().nullable(),
    /** Pedidos que ainda não chegaram (nem foram cancelados). */
    purchaseOrdersOpenCount: z.number().int().nullable(),
    fiscalDocumentsCount: z.number().int().nullable(),
    /** Competência do lançamento mais recente — "última compra". */
    lastEntryDate: z.string().nullable(),
    /** Últimos doze meses, do mais antigo ao mais recente, meses vazios incluídos. */
    byMonth: z.array(personMonthSchema),
    /** Os lançamentos mais recentes, completos, com parcelas. */
    recentEntries: z.array(financialEntrySchema),
    recentOrders: z.array(personOrderDigestSchema).nullable(),
    recentDocuments: z.array(personDocumentDigestSchema).nullable(),
});
//# sourceMappingURL=person-summary.js.map